'use strict';
/**
 * Description  领域热点详情页
 */
angular.module('PlanHotPointDetailModule', []).controller('planHotPointDetailCtrl', ['$scope', '$location', '$q', '$stateParams', '$filter', 'trsHttpService','$state','storageListenerService', function($scope, $location, $q, $stateParams, $filter, trsHttpService,$state,storageListenerService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus(){
        //获取二级概览图表页(热点分析)
        $scope.hotAnalysisParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotpointnewslist1",
            clusterid:$stateParams.clusterid,
            user_id: "",
            department: "",
            tenantid:""
        };
        //热点走势
        $scope.hotTrendParams={
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotTrend",
            clusterid:$stateParams.clusterid,
            user_id: "",
            department: ""
        };
        //媒体报道数
        $scope.mediaReportParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotRelationInfo",
            clusterid:$stateParams.clusterid,
            entityfield: "MEDIAREPORTPOWER",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //媒体渠道占比
        $scope.mediaReportPropParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotRelationInfo",
            clusterid:$stateParams.clusterid,
            entityfield: "REPORT_MEDIA",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //地图
        $scope.echartsMapsParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotRelationInfo",
            clusterid:$stateParams.clusterid,
            entityfield: "AREA",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //各地域报道量排名
        $scope.areaReportParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotRelationInfo",
            clusterid:$stateParams.clusterid,
            entityfield: "AREA",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //热点提及政策或文章
        $scope.policyaArticleParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotRelationInfo",
            clusterid:$stateParams.clusterid,
            entityfield: "EVENT_POLICY",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //各方观点
        $scope.viewPointParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "hotRelationInfo",
            clusterid:$stateParams.clusterid,
            entityfield: "VIEWPOINT",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //分页数据
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 6,
            ITEMCOUNT: 0,
            PAGECOUNT: 1
        };
        //集团自有媒体稿件
        $scope.mediaOwnReportParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "xhsOriginalNews",
            clusterid:$stateParams.clusterid,
            page_no:$scope.page.CURRPAGE - 1,
            page_size:$scope.page.PAGESIZE,
            zbtype: "all",
            user_id: "",
            tenantid:"",
            department: ""
        };
        //获取获取集团稿件类型
        $scope.xhsOriginalNewsTypeParams = {
            typeid: "widget",
            serviceid: "hotpointevent",
            modelid: "xhsOriginalNewsType",
            clusterid:$stateParams.clusterid,
            user_id: "",
            tenantid:"",
            department: ""
        };
        $scope.data={
            TITLE:"",//标题
            STATUS:"",//热点趋势
            WEIGHTEDNUMS:"",//热度值
            REPORTNUM:"",//报道数
            KEEPTIME:"",//今日热点持续
            FIELD:"",//事件分类名
            EVENTTIPPING3:"",//引爆媒体
            KEYWORDS:"",//热点关键词
            AREAKEYWORDS:"",//相关区域
            ORGANIZATIONKEYWORDS:"",//相关机构
            PEOPLEKEYWORDS:"",//相关人物
            hotTrend:"",//热点趋势
            mediaReport:"",//媒体报道数
            echartsMapsData:"",//地图数据
            areaReportParams:"",//新华社稿件传播情况
            policyaArticleData:"",//相关政策
            viewPointData:"",//各方观点
            mediaOwnReportData:"",//媒体自有稿件
            xhsOriginalNewsTypeData:[
                {type:"all",value:'全部渠道'}
            ],//获取获取集团稿件类型
            selectChannel:"all",
            hotpointdetail:[],//总的数据
            caluData:{
                colorArr:[]
            },
            PUBTIME:[]//发布时间
        };
        $scope.status = {
            params: {
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE
            },
            isSearch: false,
            copyCurrPage: 1
        }
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData(){
        randomColorValue();
        getHotAnalysisData();
        relatePolicy();
        getViewPoint();
    }
    $scope.selectChannelData=function(type){
        $scope.data.selectChannel=type;
        $scope.mediaOwnReportParams.zbtype=type;
    };
    /**
     * [detailPreview description] 进入文章详情页
     * @return {[type]} [description]
     */
    $scope.detailPreview = function(guid) {
        var url = $state.href("resourcedetail", { guid: guid});
        window.open(url, "_blank");
        relatePolicy();
        getViewPoint();
    };
    /**
     * [pageChanged description]集团自有媒体稿件展示分页
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.mediaOwnReportParams.page_no = $scope.page.CURRPAGE - 1; //re
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
    };

    // $scope.selectPageNum = function() {
    //     $scope.params.page_no = $scope.page.CURRPAGE - 1;
    //     $scope.params.page_size = $scope.page.PAGESIZE;
    //     $scope.status.copyCurrPage = $scope.page.CURRPAGE;
    // };
    /**
     * [jumpToPage description:跳转指定页面]
     */
    // $scope.jumpToPage = function() {
    //     if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
    //         $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
    //     } else if ($scope.status.copyCurrPage < 1) {
    //         $scope.status.copyCurrPage = 1;
    //     }
    //     $scope.params.page_no = $scope.status.copyCurrPage - 1;
    //     $scope.page.CURRPAGE = $scope.status.copyCurrPage;
    // };
    function getHotAnalysisData(){
        //获取二级概览图表页(热点分析)
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.hotAnalysisParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.hotpointdetail=data;
                $scope.data.EVENTTIPPING3=getJsonDatas(data.EVENTTIPPING3);
                $scope.data.KEEPTIME=data.KEEPTIME.split(";");
                $scope.data.KEEPTIME.pop();
                $scope.data.KEYWORDS=getJsonDatas(data.KEYWORDS);
                $scope.data.PEOPLEKEYWORDS=getJsonDatas(data.PEOPLEKEYWORDS);
                $scope.data.ORGANIZATIONKEYWORDS=getJsonDatas(data.ORGANIZATIONKEYWORDS);
                $scope.data.AREAKEYWORDS=getJsonDatas(data.AREAKEYWORDS);
                $scope.data.KEYWORDS.splice(7);
                $scope.data.PEOPLEKEYWORDS.splice(7);
                $scope.data.ORGANIZATIONKEYWORDS.splice(7);
                $scope.data.AREAKEYWORDS.splice(7);
            }

        });
        //热点走势
        $scope.loadingPromise =trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.hotTrendParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.hotTrend=data
            }
        });
        //媒体报道数
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.mediaReportParams, "get").then(function(data) {
            if(angular.isDefined(data)){
               $scope.data.mediaReport=data.splice(0,8);
            }
        });
        //媒体渠道占比
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.mediaReportPropParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.mediaReportProp=data.splice(0,8);
                pieChartHotLegendInit();
            }
        });
        //地图数据
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.echartsMapsParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.echartsMapsData=data;
            }
        });
        //新华社稿件传播情况
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.areaReportParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.areaReportParams=data;
            }
        });
        //获取获取集团稿件类型
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.xhsOriginalNewsTypeParams, "get").then(function(data) {
            var typeValue='';
            if(angular.isDefined(data)){
                angular.forEach(data,function(value,index){
                    if(index=='wz'){
                        typeValue="网站";
                    }
                    if(index=='wx'){
                        typeValue="微信";
                    }
                    if(index=='szb'){
                        typeValue="数字报";
                    }
                    if(index=='app'){
                        typeValue="客户端";
                    }
                    $scope.data.xhsOriginalNewsTypeData.push(
                        {
                            type:index,
                            value:typeValue
                        }
                    );
                });
            }
        });
        //获取集团原创稿件
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.mediaOwnReportParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.mediaOwnReportData=data.PAGEITEMS;
                $scope.page.ITEMCOUNT = data.TOTALITEMCOUNT;
                $scope.page.PAGECOUNT = data.PAGETOTAL;
                angular.forEach(data.PAGEITEMS,function(value,index){
                    var date = $filter('date')(new Date(value.PUBTIME), 'HH:mm:ss');
                    $scope.data.PUBTIME.push(date);
                });
            }
        });


    };
    /**
     * [pageChanged description] 相关政策及文章
     * @return {[type]} [description]
     */
    function relatePolicy(){
        //相关政策
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.policyaArticleParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.policyaArticleData=data;
                var listArray = [];
                if (data.result === "success") {
                    listArray = data;
                }
                storageListenerService.appendPageTurningStorage(listArray, "guid", "resourceDetail",'ZB_GUID');
            }
        });
    };
    /**
     * [pageChanged description] 各方观点
     * @return {[type]} [description]
     */
    function getViewPoint(){
        //各方观点
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewPointParams, "get").then(function(data) {
            if(angular.isDefined(data)){
                $scope.data.viewPointData=data;
            }
        });
    }
    function getJsonDatas(obj){
        var jsonValue=[];
        if(obj!=""){
            obj=obj.split(";");
            obj.pop();
            for(var i=0;i<obj.length;i++){
                if(obj[i]=="" || typeof obj[i]==undefined){
                    obj.splice(i,1);
                    i=i-1;
                }
            }
            for(var i=0;i<obj.length;i++){
                jsonValue.push({
                    "name":obj[i].split(":")[0],
                    "value":obj[i].split(":")[1]
                });
            }
            return jsonValue;
        }

    };
    function randomColorValue(){
        for(var i=0;i<3;i++){
            $scope.data.caluData.colorArr.push(Math.ceil(Math.random()*10));
        }
       return  $scope.data.caluData.colorArr;
    }
    /**
     * [pieChartHotLegendInit description] 热点渠道分析饼图图标样式初始化
     * @return {[type]} [description]
     */
    function pieChartHotLegendInit() {
        var colors = ['#5A90F8', '#5EBDE9', '#FAB953', '#57CEC5', '#c3b4df'];
        var ul = $('<ul class="legendList"></ul>');
        var sumData = 0;
        for (var j = 0; j < $scope.data.mediaReportProp.length; j++) {
            sumData += $scope.data.mediaReportProp[j].VALUE;
        }
        for (var i = 0; i < $scope.data.mediaReportProp.length; i++) {
            $scope.data.mediaReportProp[i].percent = $scope.data.mediaReportProp[i].VALUE / sumData * 100;
            ul.append('<li><span class="name"><span class="legendIcon" style="background:' + colors[i % 5] + '"></span>'+$scope.data.mediaReportProp[i].KEYWORD+'</span><i></i><span class="percent">'+$scope.data.mediaReportProp[i].percent.toFixed(2)+'%</span></li>');
        }
        $('.legendContainer').append(ul);
    }








}]);
